import React, {Suspense, useEffect, useState} from "react";
import ErrorBoundary from "../../../utils/ErrorBoundary";
import {ButtonPropType} from "../paypal/helpers/paypalTypes";
import ApplePayButtonLoader from "./ApplePayButtonLoader";
import BraintreeButton, {PayPalLoadingSpinner} from "../paypal/BraintreeButton";

// ApplePayButton(Boundary) -> ApplePayButtonValidator -> ApplePayButtonLoader
const ApplePayButton: React.FC<ButtonPropType> = (props) => (
  <ErrorBoundary fallback={null} handleError={props.handleError} occurrence="Apple Pay Button">
    <Suspense fallback={null}>
      <ApplePayButtonValidator {...props} />
    </Suspense>
  </ErrorBoundary>
);

export default ApplePayButton;

const ApplePayButtonValidator: React.FC<ButtonPropType> = (props) => {
  const [supportedVersion, setSupportedVersion] = useState<number | null>(null);

  useEffect(() => {
    let tempSupportedVersion = 0;

    // - Is a braintree client given
    // - Are we in Safari (has _global_ `ApplePaySession` ctor)
    // - Does device support Apple Pay
    // - Are necessary version numbers supported (beginning with the lowest)
    if (
      window.ApplePaySession &&
      ApplePaySession.canMakePayments()
    ) {
      [3, 4, 5, 6].some((version) => {
        // https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778014-supportsversion#parameters
        if (ApplePaySession.supportsVersion(version)) {
          tempSupportedVersion = version;

          return true;
        } else {
          return false;
        }
      });
    }

    setSupportedVersion(tempSupportedVersion);
  }, []);

  if (supportedVersion === null) {
    return (
      <div className="apple-pay-button-container">
        <div className="spinner-container">
          <PayPalLoadingSpinner />
        </div>
      </div>
    );
  }

  if (supportedVersion === 0) {
    if (props.place !== "pdp") {
      return null;
    }

    // Validation reveals there is no Apple Pay available. Showing off PayPal
    return <BraintreeButton {...props} />;
  }

  return <ApplePayButtonLoader {...props} supportedVersion={supportedVersion} />;
};
